import {
  cdnUrlFromStorageKey,
  quotedFilestackStoreFilename,
} from "utils/sanitizeUploadFilename";
import {
  documentIsHidden,
  whenDocumentVisible,
} from "utils/whenDocumentVisible";

var notifyUploadError = function (payload, error) {
  if (!payload || typeof payload.onError !== "function") return;
  if (error && error.uploadErrorNotified) return;
  if (error && typeof error === "object") error.uploadErrorNotified = true;
  payload.onError(error);
};

var getJson = function (url, onSuccess, onFail) {
  var attempts = 0;
  var finished = false;

  function failOnce() {
    if (finished) return;
    finished = true;
    onFail();
  }

  function send() {
    if (finished) return;
    attempts += 1;
    $.ajax({
      type: "GET",
      url: url,
      dataType: "json",
      success: function (data) {
        if (finished) return;
        finished = true;
        onSuccess(data);
      },
      error: function (_xhr, textStatus) {
        if (finished) return;
        if (attempts < 3 && (textStatus === "abort" || documentIsHidden())) {
          whenDocumentVisible(send);
          return;
        }
        failOnce();
      },
    });
  }

  send();
};

var transform = function (upload_type, payload, file) {
  return new Promise(function (resolve, reject) {
    function fail(message, reason) {
      var error =
        message instanceof Error
          ? message
          : new Error(message || "Image upload failed");
      notifyUploadError(payload, error);
      if (typeof payload.onUploadFailed === "function") {
        payload.onUploadFailed(reason || "transform");
      }
      reject(error);
    }

    function runTransform(upload_type, payload, file) {
      var isGif =
        (file.mimetype && file.mimetype.indexOf("gif") > -1) ||
        (file.filename && file.filename.toLowerCase().indexOf(".gif") > -1);

      var storeParams = `store=l:s3,a:public,r:us-east-1,c:uploads.convertflow.co,p:"${
        payload.environment
      }${payload.path}",f:${quotedFilestackStoreFilename(
        file.filename,
        isGif
      )}`;

      var isPng =
        (file.mimetype && file.mimetype.indexOf("png") > -1) ||
        (file.filename && file.filename.toLowerCase().indexOf(".png") > -1);

      var resizeParams = payload.skipProcessImage
        ? "resize=w:2000,h:8000,f:max"
        : "resize=w:2000,f:max";

      var outputParams = isPng
        ? "output=format:webp,quality:90,strip:true"
        : "output=format:webp,quality:100";

      var transformation_url = isGif
        ? `https://cdn.filestackcontent.com/${storeParams}/${file.handle}`
        : isPng
        ? `https://cdn.filestackcontent.com/${outputParams}/${resizeParams}/${storeParams}/${file.handle}`
        : `https://cdn.filestackcontent.com/${resizeParams}/${outputParams}/${storeParams}/${file.handle}`;

      getJson(
        transformation_url,
        function (data) {
          uploads.callback(upload_type, payload, file, data);
          resolve(data);
        },
        function () {
          fail(new Error("Image transform failed"), "transform");
        }
      );
    }

    function handleNSFW(upload_type, payload, file, sfw) {
      $.ajax({
        type: "POST",
        url: window.location.origin + "/users/process_image?process_type=nsfw",
        dataType: "json",
        data: {
          file_path: file.key,
          file_type: file.mimetype,
          file_url: cdnUrlFromStorageKey(file.key),
          preview_handle: file.handle,
          sfw: sfw,
          user_id: payload.user_id,
          website_id: payload.website_id,
          account_id: payload.account_id,
        },
      });
      if (
        typeof payload.onUploadFailed !== "function" &&
        typeof payload.onError !== "function"
      ) {
        alert(
          "This image does not meet our content policies. Please upload another image."
        );
      }
      fail(new Error("Image rejected by content policy"), "nsfw");
    }

    function sfwCheck(upload_type, payload, file) {
      getJson(
        "https://cdn.filestackcontent.com/security=p:eyJleHBpcnkiOjE5Mjg3MjUyMDB9,s:ea4369b4da7099fb01d337d687464e6c5fa50bf4c59afc8fc1f94aad14e023e4/sfw/" +
          file.handle,
        function (response) {
          try {
            if (!response || typeof response !== "object") {
              fail(new Error("Image safety check failed"), "sfw");
              return;
            }
            if (response["sfw"] == true) {
              runTransform(upload_type, payload, file);
            } else if (Object.prototype.hasOwnProperty.call(response, "sfw")) {
              handleNSFW(upload_type, payload, file, response["sfw"]);
            } else {
              fail(new Error("Image safety check failed"), "sfw");
            }
          } catch (error) {
            fail(error, "sfw");
          }
        },
        function () {
          fail(new Error("Image safety check failed"), "sfw");
        }
      );
    }

    var plan = $("#upgrade").attr("data-plan");
    var plan_type = $("#upgrade").attr("data-plan-type");
    var trial = $("#upgrade").attr("data-trial");
    var admin_type = $("#upgrade").attr("data-admin-type");
    var isSuperAdmin =
      payload.super_admin === true ||
      Boolean(payload.admin_type) ||
      Boolean(admin_type);

    const needsNSFWCheck =
      !isSuperAdmin &&
      (payload.forceNsfwCheck ||
        plan_type == "free" ||
        (trial == "true" && plan.indexOf("shopify") == -1));

    if (needsNSFWCheck) {
      sfwCheck(upload_type, payload, file);
    } else {
      runTransform(upload_type, payload, file);
    }
  });
};

export default transform;
